import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import useMediaQuery from "@mui/material/useMediaQuery";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import "../Styles/Navbar.css";

const Navbar = () => {
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [visible, setVisible] = useState(true);
  const lastScrollY = useRef(0);

  useEffect(() => {
    lastScrollY.current = window.scrollY;
    const handleScroll = () => {
      const currentY = window.scrollY;
      if (currentY < 10 || currentY < lastScrollY.current) {
        setVisible(true);
      } else {
        setVisible(false);
      }
      lastScrollY.current = currentY;
    };
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawerOpen(open);
  };

  const drawerContent = (
    <Box
      sx={{ width: 250 }}
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}>
      <List>
        {["Home", "About", "Outreach", "Contact", "FAQ"].map((text) => (
          <ListItem
            button
            key={text}
            component={Link}
            to={text.toLowerCase() === "home" ? "/" : `/${text.toLowerCase()}`}>
            <ListItemText primary={text} />
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <Box className={`navbar${visible ? "" : " navbar--hidden"}`}>
      <div className="logo">
        <Link
          to="/"
          style={{ textDecoration: "none", color: "white" }}>
          <img
            src={require("../Assets/yosa.png")}
            alt="Logo"
            style={{ height: "40px" }}
          />
        </Link>
      </div>
      {isSmallScreen ? (
        <>
          <IconButton
            edge="end"
            color="inherit"
            aria-label="menu"
            onClick={toggleDrawer(true)}>
            <MenuIcon />
          </IconButton>
          <Drawer
            anchor="right"
            open={drawerOpen}
            onClose={toggleDrawer(false)}>
            {drawerContent}
          </Drawer>
        </>
      ) : (
        <div className="navButtons">
          {["Home", "About", "Outreach", "Contact", "FAQ"].map((text) => (
            <Button
              variant="text"
              size="large"
              component={Link}
              to={
                text.toLowerCase() === "home" ? "/" : `/${text.toLowerCase()}`
              }
              className="navButton"
              key={text}>
              {text}
            </Button>
          ))}
        </div>
      )}
    </Box>
  );
};

export default Navbar;
